export default __webpack_public_path__ + "static/media/UploadImage.15ea1f76.svg";